import { css } from '@emotion/react';
import { theme } from 'global';

export const productsAndOffersTableContainer = (sidebarOpen) => css`
  width: 100%;
  padding: 32px;

  @media screen and (max-width: ${theme.breaks.lg - 1}px) {
    width: calc(100% - ${sidebarOpen ? 332 : 0}px);
  }

  @media screen and (max-width: ${theme.breaks.sm}px) {
    background-color: transparent;
    padding: 0;
  }
`;

export const toolbar = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  & > span {
    display: flex;
    align-items: center;
    width: 400px;

    & > :not(:first-child) {
      margin-left: 12px;
    }

    @media screen and (max-width: ${theme.breaks.xs}px) {
      flex-direction: column;
      width: 100%;
      border-radius: 8px;
      border: 1px solid ${theme.colors.neutral[200]};
      background-color: ${theme.colors.white};
      box-shadow: unset;
      padding: 16px;

      & > :not(:first-child) {
        margin-left: 0;
      }
    }
  }
`;

export const select = css`
  width: 312px;
  height: 50px;
  radius: 4px;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    width: 100%;
  }
`;
